<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <!-- <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ACN_ID')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <div
            class="comm_label"
          >
            {{ frame0.actionUid }}
          </div>
        </div> -->
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ACN_NM')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            ref="actionName"
            v-model="frame0.actionName"
            maxlength="50"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ACN_TYPE')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-code-select
            ref="actionCodeType"
            :selected="frame0.selectedCode.COD_TYPE"
            codeId="COD_ACN_TYPE"
            @loaded="actionTypeLoaded"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_DVO_NM')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            ref="dvoName"
            v-model="frame0.dvoName"
            maxlength="100"
          />
        </div>     
        <div class="col-xs-1">
          <sui-input-label
            label="Springbean ID"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-text-field
            ref="springBeanId"
            v-model="frame0.springBeanId"
            maxlength="100"
          />
          <div class="comp_spacing"/>
          <sui-button
            type="button"
            name="button"
            class="comm_btn_duplicate"
            @click="onClickCheck"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_FNC_NM')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <!-- <sui-code-select
            :selected="selectedCode"
            codeId=""
          /> -->
          <sui-text-field
            ref="actionFunctionName"
            v-model="frame0.actionFunctionName"
            maxlength="25"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_USE_YN')"
            :vertical="false"
            required
          />
        </div>
        <div class="col-xs-5">
          <sui-radio
            v-model="frame0.actionUseYn"
            value="Y"
          >
            Yes
          </sui-radio>
          <sui-radio
            v-model="frame0.actionUseYn"
            value="N"
          >
            No
          </sui-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_ACN_CNTN')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-11">
          <textarea
            v-model="frame0.actionExplanationContent"
            maxlength="1000"
          />
        </div>
      </div>
      <div
        v-if="!systemInfoShow"
        class="row"
      >
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <cmp-user-name-link
            :pageId="pageId"
            :displayType="'1'"
            :displayLanguageId="frame0.displayLanguageIdRegistration"
            :loginId="frame0.loginIdRegistration"
            :knoxId="frame0.knoxIdRegistration"
            :userName="frame0.userNameRegistration"
            :userGlobalName="frame0.userGlobalNameRegistration"
            :departmentName="frame0.departmentNameRegistration"
            :departmentEnglishName="frame0.departmentEnglishNameRegistration"
            :type="'link'"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <div class="comm_label">
            {{ frame0.firstRegistrationDTM }}
          </div>
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <cmp-user-name-link
            :pageId="pageId"
            :displayType="'1'"
            :displayLanguageId="frame0.displayLanguageId"
            :loginId="frame0.loginId"
            :knoxId="frame0.knoxId"
            :userName="frame0.userName"
            :userGlobalName="frame0.userGlobalName"
            :departmentName="frame0.departmentName"
            :departmentEnglishName="frame0.departmentEnglishName"
            :type="'link'"
          />
        </div>
      </div>
      <div
        v-if="!systemInfoShow"
        class="row"
      >
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <div class="comm_label">
            {{ frame0.finalModificationDTM }}
          </div>
        </div>
        <div class="col-xs-1 nodata" />
        <div class="col-xs-3" />
        <div class="col-xs-1 nodata" />
        <div class="col-xs-3" />
      </div>
    </div>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:create="pageId"
        type="button"
        class="comm_btn_border"
        @click="onClickNew"
      >
        {{ $t('MSG_BTN_NEW') }}
      </sui-button>
      <sui-button
        v-permission:delete="pageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDelete"
      >
        {{ $t('MSG_BTN_DEL') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00002_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    actionUid: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mountedFlag: true,
      frame0: {
        selectedCode: {
          COD_TYPE: {
            key: '',
            label: '',
          },
        },
        actionUid: '',
        actionName: '',
        actionType: '',
        actionExplanationContent: '',
        actionFunctionName: '',
        dvoName: '',
        springBeanId: '',
        actionUseYn: '',
        loginId: '',
        knoxId: '',
        userName: '',
        userGlobalName: '',
        departmentName: '',
        departmentEnglishName: '',
        loginIdRegistration: '',
        knoxIdRegistration: '',
        userNameRegistration: '',
        userGlobalNameRegistration: '',
        departmentNameRegistration: '',
        departmentEnglishNameRegistration: '',
        displayLanguageIdRegistration: '',
        displayLanguageId: '',
        finalModificationDTM: '',
        firstRegistrationDTM: '',
      },
    };
  },
  computed: {
    systemInfoShow() {
      return utils.isEmpty(this.actionUid);
    },
  },
  watch: {
    actionUid() {
      if (!utils.isEmpty(this.actionUid)) {
        this.setActionData();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.actionUid)) {
        this.setActionData();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 저장되지 않은 데이터 확인
     */
    makeSnapshot() {
      const snapshotData = utils.assign({},
        this.frame0,
        {
          actionTypeCode: this.frame0.selectedCode.COD_TYPE.key,
        });

      return snapshotData;
    },
    actionTypeLoaded() {
      if (this.mountedFlag) {
        this.saveSnapshot(this.makeSnapshot());
        this.mountedFlag = false;
      }
    },
    /**
     * 리셋
     */
    onClickNew() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.$refs.actionCodeType.reset();
        } else {
          this.frame0[key] = '';
        }
      });

      this.oldTextValue = '';

      this.$emit('onClickNew');
    },
    /**
     * 액션 기본 정보 셋팅
     */
    setActionData() {
      // utils.forEach(this.frame0, (value, key) => {
      //   if (utils.isEqual(key, 'selectedCode')) {
      //     this.frame0[key].COD_TYPE.key = this.selectedRowData.actionTypeCode;
      //   } else {
      //     this.frame0[key] = this.selectedRowData[key];
      //   }
      // });

      const queryParams = {
        actionUid: this.actionUid,
      };

      http.request(this.pageId, 'DTS_CMR_00001', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, ['finalModificationDTM', 'firstRegistrationDTM']);
        // this.dsAction.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
        utils.forEach(this.frame0, (value, key) => {
          if (utils.isEqual(key, 'selectedCode')) {
            this.frame0[key].COD_TYPE.key = res.data[0].actionTypeCode;
          } else {
            this.frame0[key] = res.data[0][key] || '';
          }
        });
        this.saveSnapshot(this.makeSnapshot());
      });
    },
    /**
     * 저장
     */
    onClickSave() {
      // actionUid(선택 된 row) 존재하면 insert Service 없으면 update Service
      const serviceName = utils.isEmpty(this.actionUid) ? 'DTS_CMR_00002' : 'DTS_CMR_00003';
      const dataParams = {
        actionUid: this.actionUid,
        actionName: this.frame0.actionName,
        actionExplanationContent: this.frame0.actionExplanationContent,
        actionFunctionName: this.frame0.actionFunctionName,
        dvoName: this.frame0.dvoName,
        springBeanId: this.frame0.springBeanId,
        actionUseYn: this.frame0.actionUseYn,
        actionTypeCode: this.frame0.selectedCode.COD_TYPE.key,
      };

      if (!this.validationCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, serviceName, {
          data: dataParams,
        }).then(res => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('onClickSearch');
          this.saveSnapshot(this.makeSnapshot());

          if (utils.isEmpty(this.actionUid)) {
            this.$emit('actionUidSet', res.data.msg);
          } else {
            this.setActionData();
          }
        });
      });

      return true;
    },
    /**
     * 삭제
     */
    onClickDelete() {
      const dataParams = {
        actionUid: this.actionUid,
      };

      if (utils.isEmpty(utils.trim(this.actionUid))) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        return false;
      }

      utils.messageBox('confirm', this.$t('MSG_ALT_DO_DELETE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00004', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'));
          this.$emit('onClickSearch');
          this.onClickNew();
        });
      });

      return true;
    },
    /**
     * 필수 값 입력 확인
     */
    validationCheck() {
      if (utils.isEmpty(utils.trim(this.frame0.actionName))) {
        // 액션이름을 입력하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_ACN_NM')),
          null,
          () => {
            this.$refs.actionName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_TYPE.key))) {
        // 액션유형을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_ACN_TYPE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.dvoName))) {
        // 액션이름을 입력하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_DVO_NM')),
          null,
          () => {
            this.$refs.dvoName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.springBeanId))) {
        // springBeanId 입력하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), 'springBeanId'),
          null,
          () => {
            this.$refs.springBeanId.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.actionFunctionName))) {
        // 메서드이름 입력하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_FNC_NM')),
          null,
          () => {
            this.$refs.actionFunctionName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame0.actionUseYn))) {
        // 액션유형을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_USE_YN')));
        return false;
      }

      return true;
    },
    /**
     * springBean ID 체크
     */
    onClickCheck() {
      if (!this.frame0.springBeanId) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), 'Springbean ID'));
        return;
      }
      http.request(this.pageId, 'DTS_CMR_00039', {
        path: {
          'spring-bean-id': this.frame0.springBeanId,
        },
      }).then(res => {
        utils.messageBox('information', res.data.msg);
      });
    },
  },
  datasets: [],
};
</script>
<style scoped>
</style>
